import { Component, HostBinding, Inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService, HeaderElement, HeaderSubItemType, LogService } from '@ridango/core';
import { HelperService } from '../../../../services/helper.service';
import { FeatureFlagService } from '@ridango/feature-flags';
import Env from '@ridango/core/env';
import { MatDialog } from '@angular/material/dialog';
import { ApplicationFacade, CustomerAccountsFacade, CustomerFacade } from '@ridango/components';
import { NewMobileMenuAbstractComponent } from '../new-mobile-menus-abstract.component';
import { HeaderMenuService } from '../../../../services/header-menu.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AnalyticsService } from '@ridango/core/lib/services/analytics.service';
import { CountInfo, MessagesService } from '../../../../../services/messages.service';
import { Observable } from 'rxjs';
import { Actions } from '@ngrx/effects';
import { PermissionsFacade } from '@ridango/components/lib/permissions';
import { Capacitor } from '@capacitor/core';

@Component({
    selector: 'gl-new-mobile-menu',
    templateUrl: './new-mobile-menu.component.html',
    styleUrls: ['./new-mobile-menu.component.scss']
})
export class NewMobileMenuComponent extends NewMobileMenuAbstractComponent implements OnInit {
    protected readonly HeaderSubItemType = HeaderSubItemType;
    menuItems: HeaderElement[] = [];
    receivedMessagesCount$: Observable<CountInfo>;
    @HostBinding('class.ios-device-focus')
    readonly isIosDeviceFocus = Capacitor.getPlatform() === 'ios';

    constructor(
        protected ls: LogService,
        public ridangoAuth: AuthService,
        public helperService: HelperService,
        public translate: TranslateService,
        @Inject('ENV') public env: Env,
        protected featureFlags: FeatureFlagService,
        protected dialog: MatDialog,
        protected customerFacade: CustomerFacade,
        protected applicationFacade: ApplicationFacade,
        private headerMenuService: HeaderMenuService,
        private router: Router,
        private http: HttpClient,
        public permissionsFacade: PermissionsFacade,
        public analyticsService: AnalyticsService,
        public messagesService: MessagesService,
        public actions$: Actions,
        customerAccountsFacade: CustomerAccountsFacade
    ) {
        super(
            ls,
            ridangoAuth,
            helperService,
            translate,
            env,
            dialog,
            applicationFacade,
            customerFacade,
            permissionsFacade,
            actions$,
            messagesService,
            analyticsService,
            customerAccountsFacade
        );
    }

    ngOnInit() {
        if (this.env.HEADER?.SHOW_MESSAGES) {
            this.receivedMessagesCount$ = this.messagesService.getReceivedMessagesCount();
        }
        super.ngOnInit();
        this.initializeMenu();
    }

    initializeMenu(): void {
        this.menuItems = this.headerMenuService.getMenuItems();
    }

    isMenuItemAllowed(menuItemV2: HeaderElement): boolean {
        return this.headerMenuService.isCheckBasicConditions(menuItemV2);
    }

    isActive(route: string): boolean {
        return this.router.isActive(route, true);
    }

    activateMenuItem(event: KeyboardEvent): void {
        event.preventDefault();
        const target = event.currentTarget as HTMLElement;
        target.click();
    }
}
